module.exports = __webpack_public_path__ + "static/media/profile-add-white.344de163.svg";